/**
 * variant-media-filter.js
 *
 * Shows only the product media associated with the selected variant.
 *
 * An image is associated with a variant by adding "variant--<value>" to its ALT
 * text in the Shopify admin (e.g. "variant--Navy"). The matching value is emitted
 * onto each slide/thumb as a data-variant attribute by snippets/media.liquid and
 * snippets/product.liquid. Images without a data-variant are "shared" and always
 * shown.
 *
 * Initial visibility is set server-side in Liquid; this script keeps it in sync
 * when the shopper changes variant, by listening to the theme's variantChange
 * pub/sub event published from product-info.js.
 */
!(function () {
  'use strict';

  var SLIDE_HIDDEN = 'product__slide--variant-hidden';
  var THUMB_HIDDEN = 'product__thumb--variant-hidden';

  function toggleByVariant(elements, hiddenClass, optionValues) {
    elements.forEach(function (el) {
      var value = el.getAttribute('data-variant');
      var matches = optionValues.indexOf(value) !== -1;
      el.classList.toggle(hiddenClass, !matches);
    });
  }

  function onVariantChange(event) {
    var data = event && event.data;
    if (!data || !data.variant) return;

    var optionValues = Array.isArray(data.variant.options) ? data.variant.options : [];

    var productInfo =
      document.querySelector('product-info[data-section-id="' + data.sectionId + '"]') ||
      document.querySelector('product-info[data-section="' + data.sectionId + '"]');

    if (!productInfo) return;

    toggleByVariant(productInfo.querySelectorAll('.product__slide[data-variant]'), SLIDE_HIDDEN, optionValues);
    toggleByVariant(productInfo.querySelectorAll('.product__thumb[data-variant]'), THUMB_HIDDEN, optionValues);
  }

  function init() {
    if (typeof subscribe !== 'function' || !window.theme || !window.theme.PUB_SUB_EVENTS) {
      return false;
    }

    subscribe(window.theme.PUB_SUB_EVENTS.variantChange, onVariantChange);
    return true;
  }

  if (!init()) {
    document.addEventListener('DOMContentLoaded', init);
  }
})();
